var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.47 18.3305C22.47 18.6905 22.39 19.0605 22.22 19.4205C22.05 19.7805 21.83 20.1205 21.54 20.4405C21.05 20.9805 20.51 21.3705 19.9 21.6205C19.3 21.8705 18.65 22.0005 17.95 22.0005C16.93 22.0005 15.84 21.7605 14.69 21.2705C13.54 20.7805 12.39 20.1205 11.25 19.2905C10.1 18.4505 9.01 17.5205 7.97 16.4905C6.94 15.4505 6.01 14.3605 5.18 13.2205C4.36 12.0805 3.7 10.9405 3.22 9.81049C2.74 8.67049 2.5 7.58049 2.5 6.54049C2.5 5.86049 2.62 5.21049 2.86 4.61049C3.1 4.00049 3.48 3.44049 4.01 2.94049C4.65 2.31049 5.35 2.00049 6.09 2.00049C6.37 2.00049 6.65 2.06049 6.9 2.18049C7.16 2.30049 7.39 2.48049 7.57 2.74049L9.89 6.01049C10.07 6.26049 10.2 6.49049 10.29 6.71049C10.38 6.92049 10.43 7.13049 10.43 7.32049C10.43 7.56049 10.36 7.80049 10.22 8.03049C10.09 8.26049 9.9 8.50049 9.66 8.74049L8.9 9.53049C8.79 9.64049 8.74 9.77049 8.74 9.93049C8.74 10.0105 8.75 10.0805 8.77 10.1605C8.8 10.2405 8.83 10.3005 8.85 10.3605C9.03 10.6905 9.34 11.1205 9.78 11.6405C10.23 12.1605 10.71 12.6905 11.23 13.2205C11.77 13.7505 12.29 14.2405 12.82 14.6905C13.34 15.1305 13.77 15.4305 14.11 15.6105C14.16 15.6305 14.22 15.6605 14.29 15.6905C14.37 15.7205 14.45 15.7305 14.54 15.7305C14.71 15.7305 14.84 15.6705 14.95 15.5605L15.71 14.8105C15.96 14.5605 16.2 14.3705 16.43 14.2505C16.66 14.1105 16.89 14.0405 17.14 14.0405C17.33 14.0405 17.53 14.0805 17.75 14.1705C17.97 14.2605 18.2 14.3905 18.45 14.5605L21.76 16.9105C22.02 17.0905 22.2 17.3005 22.31 17.5505C22.41 17.8005 22.47 18.0505 22.47 18.3305Z",
    stroke: "#DB4D29",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19 9.00049C19 8.40049 18.53 7.48049 17.83 6.73049C17.19 6.04049 16.34 5.50049 15.5 5.50049",
    stroke: "#DB4D29",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5 9.00049C22.5 5.13049 19.37 2.00049 15.5 2.00049",
    stroke: "#DB4D29",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCalling);
export default __webpack_public_path__ + "static/media/call-calling.c4f00f9f4ceabe8bdf14f07b34ab08a5.svg";
export { ForwardRef as ReactComponent };